import React, { Component } from "react";
import "./image.css";
import HavayarLogoSignImage from "../../assets/images/havayar/logotomorrow.png";


export default class havayarLogoHandler extends Component {
    render() {
        return (
            <img className="center" src={HavayarLogoSignImage} alt="..." />
        );
    }
}
